import React from "react";
import SEO from "../common/SEO";
import HeaderOne from "../common/header/HeaderOne";
import FooterThree from "../common/footer/FooterThree";
import SectionTitle from "../elements/sectionTitle/SectionTitle";
import AboutTwo from "../elements/about/AboutTwo";
import TeamOne from "../elements/team/TeamOne";
import BrandOne from "../elements/brand/BrandOne";
import CalltoActionFive from "../elements/calltoaction/CalltoActionFive";

const AboutUs = () => {
  return (
    <>
      <SEO title="About Us" />
      <main className="page-wrapper">
        <HeaderOne
          btnStyle="btn-small round btn-icon"
          HeaderStyle="header-not-transparent"
        />

        {/* Start Slider Area  */}
        <div
          className="slider-area slider-style-1 height-50vh bg_image"
          data-black-overlay="7"
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL}/images/bg/bg-image-12.jpg)`,
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="inner pt--80 text-center">
                  <div>
                    <h3 className="rn-sub-badge">
                      <span className="theme-gradient">What Are We</span>
                    </h3>
                  </div>
                  <h1 className="title display-one mx-2">
                    A Premier Software Consulting Partner.
                  </h1>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* End Slider Area  */}

        <AboutTwo
          title="Our Story"
          subtitle="Who Are We"
          image="./images/about/about-1.jpeg"
          imageOnLeft={true}
          content="Moftah Solutions, LLC was founded in New York City with a vision to 
            revolutionize the software consulting industry by setting a new 
            standard of excellence. <br /> <br /> Our founder, driven by a 
            passion for delivering high-quality work and services, observed a 
            prevalence of subpar freelancers in various domains. Determined to
            be the exception, he embarked on a mission to provide clients with 
            top-tier solutions that strike the perfect balance between 
            cost-effectiveness and uncompromising quality. This commitment to 
            excellence and integrity forms the core of Moftah Solutions' ethos, 
            setting us apart as a trusted partner in the industry."
        />
        <AboutTwo
          image="./images/about/about-2.jpg"
          content="With a solid foundation in education and extensive 
            experience in the tech industry, our team at Moftah Solutions brings 
            a wealth of expertise to every project. Armed with a bachelor's 
            degree in Computer Science and a master's in Information Technology, 
            our founder has honed his skills over many years in the field.
            Having worked at tech giants like Amazon, Google, and Microsoft, our
            team members possess a deep understanding of industry trends, best
            practices, and cutting-edge technologies. This rich background
            equips us to deliver innovative solutions and unparalleled service
            to our clients, ensuring that every project is executed with
            precision and excellence. <br /> <br /> At Moftah Solutions, LLC, we
            combine industry knowledge, technical proficiency, and a commitment
            to quality to provide our clients with exceptional software 
            solutions that drive success and exceed expectations."
        />

        {/* Start Elements Area  */}
        <div className="rwt-team-area rn-section-gap mx-4">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <SectionTitle
                  textAlign="text-center"
                  radiusRounded=""
                  subtitle="Our Experts"
                  title="Our Expert Team."
                  description=""
                />
              </div>
            </div>
            <TeamOne
              column="col-lg-6 col-md-6 mt--30"
              teamStyle="team-style-default"
            />
          </div>
        </div>
        {/* End Elements Area  */}

        {/* Start Brand Area  */}
        <div className="rwt-brand-area rn-section-gapBottom mx-4">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <SectionTitle
                  textAlign="text-center"
                  radiusRounded=""
                  subtitle="Our Clients"
                  title="Our Awesome Clients."
                  description=""
                />
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12 mt--40">
                <BrandOne brandStyle="brand-style-1" />
              </div>
            </div>
          </div>
        </div>
        {/* End Brand Area  */}

        {/* Start Elements Area  */}
        <div className="rwt-callto-action-area rn-section-gapBottom mx-4">
          <div className="wrapper">
            <CalltoActionFive />
          </div>
        </div>
        {/* End Elements Area  */}

        <FooterThree />
      </main>
    </>
  );
};

export default AboutUs;
